export default __webpack_public_path__ + "static/media/qrcode-open-app-prod.fc1c26c9.jpg";